<template>
  <div class="safety">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'safety',
  components: {
  }
}
</script>
<style lang="less" scoped>
</style>
